const isNullish = valueNumber => (Number.isNaN(valueNumber) || valueNumber === undefined || valueNumber === null);

/**
 *
 * @type {Ktable.GetOperationFn}
 */
export const sum = values => {
	let count = 0;

	for (const value of values) {
		const { cells } = value;

		if (cells.length > 1) {
			console.error('Too much cells');
		}
		else {
			const cell = cells[0];
			/** @type {string | number} */
			const v = cell.name;
			const valueNumber = typeof v === 'string' ? Number.parseFloat(v) : v;

			count += isNullish(valueNumber) ? 0 : valueNumber;
		}
	}

	return count;
};

/**
 *
 * @type {Ktable.GetOperationFn}
 */
export const avg = values => {
	let count = 0;

	for (const value of values) {
		const { cells } = value;

		if (cells.length > 1) {
			console.error('Too much cells');
		}
		else {
			const cell = cells[0];
			/** @type {string | number} */
			const v = cell.name;
			const valueNumber = typeof v === 'string' ? Number.parseFloat(v) : v;
			count += isNullish(valueNumber) ? 0 : valueNumber;
		}
	}

	const result = count === 0 ? 0 : Math.round((count / values.length) * 100) / 100;

	return result;
};

/**
 *
 * @type {Ktable.GetOperationFn}
 */
export const max = values => {
	const m = values
		.map(value => {
			const cell = value.cells[0];
			/** @type {string | number} */
			const v = cell.name;
			const valueNumber = typeof v === 'string' ? Number.parseFloat(v) : v;
			return valueNumber;
		})
		.filter(v => !isNullish(v));

	return Math.max(...m).toString();
};

/**
 *
 * @type {Ktable.GetOperationFn}
 */
export const min = values => {
	const m = values
		.map(value => {
			const cell = value.cells[0];
			/** @type {string | number} */
			const v = cell.name;
			const valueNumber = typeof v === 'string' ? Number.parseFloat(v) : v;
			return valueNumber;
		})
		.filter(v => !isNullish(v));

	return Math.min(...m).toString();
};

/**
 *
 * @type {Ktable.GetOperationFn}
 */
export const notEmpty = values => {
	const m = values.map(value => {
		if (value && value.cells && Array.isArray(value.cells) && value.cells.length > 0) {
			const content = value.cells.map(cell => cell.name).join('');

			return content !== '';
		}
		return false;
	});

	// count truthy values
	return m.filter(v => v).length;
};
